function nameString(salutation, firstName, lastName) {
	const fullName = [salutation, firstName, lastName]
		.join(' ')
		.replace(/  +/g, ' ')
		.trim();
	return fullName;
}
export default nameString;
